import { Fragment, useMemo } from 'react';

import { splitLinks } from '@/lib/link-text';

/**
 * Renders a raw widget message with any URLs turned into links. The widget has
 * no rich-text parsing, so this is the whole text pipeline for a bubble.
 */
export function WidgetMessageText({ text }: { text: string }) {
    const segments = useMemo(() => splitLinks(text), [text]);

    return (
        <>
            {segments.map((segment, i) =>
                segment.type === 'link' ? (
                    <a
                        key={`link-${i}`}
                        href={segment.href}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="op-link"
                    >
                        {segment.value}
                    </a>
                ) : (
                    <Fragment key={`text-${i}`}>{segment.value}</Fragment>
                ),
            )}
        </>
    );
}
